import React, { useCallback, useEffect, useMemo, useState } from "react";

import { useSelector } from "react-redux";

import { swSettings } from "app/common/services/swSettings";
import { EPageIdOption, SegmentsUpsaleBanner } from "app/pages/segments/upsale-banner/SegmentsUpsaleBanner";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { EMPTY_CUSTOM_SEGMENTS } from "app/services/segments/segmentsApiService";
import { SegmentsUtils } from "app/services/segments/SegmentsUtils";

import LeadingFoldersPanelInfoContainer from "../website-content/leading-folders/components/LeadingFoldersPanelInfoContainer";

import FoldersTable from "./foldersTable/FoldersTable";

export const Folders = () => {
    const services = React.useMemo(
        () => ({
            swNavigator: proNavigator,
            swSettings: swSettings,
        }),
        [],
    );
    const params = services.swNavigator.getParams();
    const isCompare = params?.key?.split(",").length > 1;
    const keysArr = isCompare ? params?.key?.split(",") : [params?.key];
    const isHasFolderAnalysis = services.swSettings.components.Home.resources.HasFolderAnalysis;
    const { customSegmentsMeta } = useSelector((state) => {
        const {
            segmentsModule: { customSegmentsMeta = EMPTY_CUSTOM_SEGMENTS },
        } = state;
        return { customSegmentsMeta };
    });
    const doSegmentsExist = useMemo(
        () => SegmentsUtils.doSegmentsExistInAccount(customSegmentsMeta) || SegmentsUtils.doSegmentsExistInUserData(),
        [customSegmentsMeta],
    );
    const [displaySegmentsUpsaleBanner, setDisplaySegmentsUpsaleBanner] = useState(false);
    const closeSegmentsUpsaleBanner = useCallback(() => setDisplaySegmentsUpsaleBanner(false), []);

    useEffect(() => {
        if (!doSegmentsExist) {
            setDisplaySegmentsUpsaleBanner(true);
        } else {
            setDisplaySegmentsUpsaleBanner(false);
        }
    }, [doSegmentsExist]);

    const isBannerVisible: boolean = proNavigator.current().viewConfig?.hideBanner !== true;

    return (
        <>
            {isBannerVisible ? (
                <SegmentsUpsaleBanner
                    isTopBanner
                    pageId={EPageIdOption.FOLDERS_ANALYSIS}
                    isVisible={displaySegmentsUpsaleBanner}
                    closeBanner={closeSegmentsUpsaleBanner}
                />
            ) : null}
            {isHasFolderAnalysis && params.webSource !== "MobileWeb" ? <LeadingFoldersPanelInfoContainer /> : null}
            <FoldersTable
                params={params}
                folderKey={keysArr[0]}
                isCompare={isCompare}
                keysArr={keysArr}
            />
        </>
    );
};
